import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../i18n/getLocale';

const open = {opacity: 1, display: 'block', backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png')"};
const closed = {opacity: 0, display: 'none'};

class Overlay extends Component {

  // constructor
  constructor(props) {
    super(props);
    this.state = {
      style: closed,
      open: open,
      closed: closed,
      status: 'closed',
      mensagem: '',
      tipo: '',
      style_alert: {
        alert: {}, icon: ''
      },
      style_error: {
        alert: {
          color: '#a94442',
          background: '#f2dede',
        },
        icon: 'fa fa-fw fa-times-circle'
      },
      style_success: {
        alert: {
          color: '#3c763d',
          background: '#d6e9c6',
        },
        icon: 'fa fa-fw fa-check'
      },
      style_warning: {
        alert: {
          color: '#8a6d3b',
          background: '#fcf8e3',
        },
        icon: 'fa fa-fw fa-exclamation-triangle'
      },
      style_info: {
        alert: {
          color: '#31708f',
          background: '#d9edf7',
        },
        icon: 'fa fa-fw fa-info-circle'
      },
    };

    this.fechar = this.fechar.bind(this);
    this.handleProps = this.handleProps.bind(this);

    this.locale = getLocale();

  }
  componentWillMount() {
    this.handleProps(this.props);
  }
  componentWillReceiveProps(newProps) {
    this.handleProps(newProps);
  }

  handleProps(props) {
    // Verifico se há mudança sobre estar aberto ou fechado
    if(this.state.status !== props.overlay.status) {
      if (props.overlay.status === 'open') {
        this.setState({style: this.state.open});
      } else {
        this.setState({style: this.state.closed});
      }
    }

    // Gravo as informações padrão
    this.setState({status: props.overlay.status});
    this.setState({message: props.overlay.message});
    this.setState({type: props.overlay.type});

    // Verifico qual o estilo da mensagem
    switch(props.overlay.type) {
      case 'error':
        this.setState({style_alert: this.state.style_error});
        break;
      case 'success':
        this.setState({style_alert: this.state.style_success});
        break;
      case 'warning':
        this.setState({style_alert: this.state.style_warning});
        break;
      case 'info':
        this.setState({style_alert: this.state.style_info});
        break;
    }
  }

  fechar() {
    this.setState({style: this.state.closed, status: 'closed'});
    this.props.handleAlert('', '', '', 'reset');
  }

  render() {
    return (
      <div>
        {(this.state.message !== '' || this.state.type !== '') ?
          <div className="loading" style={this.state.style} onClick={this.fechar}>
            <div className="alerta-container" style={this.state.style_alert.alert}>
              <div className="row">
                <div className="col-md-11 text-left">
                  <i className={this.state.style_alert.icon}></i> {this.state.message}
                </div>
                <div className="col-md-1 text-right">
                  <div className="fechar-alerta" onClick={this.fechar}>
                    <i className="fa fa-fw fa-close"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        :
          <div className="loading" style={this.state.style}>
            <div className="loading-spinning">
              <i className="fa fa-fw fa-spinner fa-spin"></i>
              <br/>
              <p className="loading-text"><span>{this.locale.Miscelania.Overlay.paragrafoCarregando}</span></p>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/Overlay.js